@if (loading()) {
<loading [stroke]="spinnerStroke()"
         [scale]="0.8"
         [size]="spinnerSize()"
         [strokeWidth]="spinnerStrokeWidth()"></loading>
} @else {
<ng-content></ng-content>
}